import { TweenMax } from 'gsap';

export default function line(el) {
  TweenMax.set(el, {
    scaleX: 0,
    transformOrigin: '0% 50%',
  });

  return el;
}
